const SCREEN = {
  NAVIGATION: 'Navigation',
};

const ITEM = {
  HOME: 'Home',
  USAGE: 'Usage',
  ACCOUNT: 'Account',
  HELP: 'Help',
  SIGNOUT: 'Logout',
};

const ACTION = {
  CLICK: 'Click',
};

export { ACTION, ITEM, SCREEN };
